package tailwind.color

class BiModalColor(private val colorName: String, private val colorVariant: String) : Color {
  override fun toString(): String {
    return "${colorName}-${colorVariant}"
  }
}

fun createColor(colorName: String): (String) -> BiModalColor = { BiModalColor(colorName, it) }
